export const ImportRowInstructionsDoordash = () => {
  return (
    <>
      <div className="_text-align--center _margin-bottom--1rem">
        <img src="/images/logos/doordash_logo.svg" style={{ height: "2rem" }} />
      </div>
      <p className="_margin-bottom--1rem">
        In order to import your Doordash orders, you will need to download your
        order history from Doordash.
      </p>

      <p className="_margin-bottom--1rem">
        Follow the steps below to download your Doordash order history:
      </p>
      <ol className="spaced_ordered_list _margin-left--1rem _list-style-type--auto">
        <li>Login to your Doordash account on your computer.</li>
        <li>
          Click on the &apos;Account&apos; icon at the bottom of the left
          sidebar
        </li>
        <li>
          In the resulting popup window, click the &apos;Account&apos; option,
          underneath the &apos;Account Settings&apos; section.
        </li>
        <li>On the resulting screen, click &apos;Manage Account&apos;.</li>
        <li>Click the &quot;Request Archive&quot; button.</li>
        <li>Complete the Two-Step Authentication process.</li>
        <li>Wait for the email from Doordash to arrive in your inbox.</li>
        <li>Download the zip file from the email.</li>
        <li>Unzip the file.</li>
        <li>
          Upload the <b>orders.csv</b> file from the unzipped folder here.
        </li>
      </ol>
    </>
  );
};
